





























import { Component, Vue, Inject, Ref, Watch } from 'vue-property-decorator';

import ServizioPeriodicoList from './ServizioPeriodicoList.vue';
import { CrudService } from '@/data/services/crud.service';
import ServizioPeriodicoFilter from './ServizioPeriodicoFilter.vue';
import { Search } from '@/data/models/search.model';
import store, { State } from '@/store';
import { PeriodicService } from '@/data/models/periodicservice.model';
import { ServiceInstanceService } from '@/data/services/serviceinstance.service';

@Component({
	components: {
		ServizioPeriodicoList,
		ServizioPeriodicoFilter,
	},
})
export default class ServiziPeriodici extends Vue {
	@Inject('CrudService') crudService!: CrudService<PeriodicService>;
	@Inject('ServiceInstanceService') serviceinstanceService!: ServiceInstanceService;

	@Ref('list') list!: ServizioPeriodicoList;
	@Ref('filter') filter!: ServizioPeriodicoFilter;

	state!: State;

	constructor() {
		super();
		this.state = store;
	}

	@Watch('state.headquarter', { deep: true })
	onHQChange() {
		this.filter.reset();
	}

	mounted() {
		this.filter.search();
	}

	onSearch(event: Search) {
		this.list.advancedSearch = event;
		this.list.load();
	}

	deleteServizioPeriodico(item: PeriodicService) {
		this.$buefy.dialog.confirm({
			message: this.$t('warning-servizio-periodico-delete') as string,
			type: 'is-danger',
			hasIcon: true,
			cancelText: this.$t('annulla') as string,
			onConfirm: () => {
				this.crudService
					.deleteEntity(PeriodicService, 'periodicservice', item)
					.then(() => {
						this.list.load();
					})
					.catch((error) => {
						this.$buefy.notification.open({
							message: error.msg,
							type: 'is-danger',
						});
					});
			},
		});
	}

}
